import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Media } from 'src/app/core/media.service';
import { MediaTypeEnum } from 'src/_api';


@Component({
  selector: 'flow-view-media-modal',
  templateUrl: './view-media.modal.html',
  styleUrls: ['./view-media.modal.scss']
})
export class ViewMediaModal implements OnInit {

  MediaTypeEnum = MediaTypeEnum;

  constructor(
    public dialogRef: MatDialogRef<ViewMediaModal>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData
  ) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}

interface ModalData {
  title?: string;
  media?: Media;
}
